








































































































































import { Component, Vue, Prop } from "vue-property-decorator";
import ExpansionPanel from "@/components/ui/ExpansionPanel.vue";
import moment from "moment";
import { translate, formatDecimal2, formatDecimal } from "@/utils";

import { InvoicesModule } from "@/store/invoices.module";
import { Invoice, InvoiceDetails } from "~/invoices.type";

@Component({
  components: { ExpansionPanel },
  watch: {
    options: "getInvoice",
  },
  filters: {
    formatDate: function(date: Date) {
      return moment(date).format("DD.MM.YYYY");
    },
    formatMonth: function(date: Date) {
      return moment(date).format("MM.YYYY");
    },
  },
})
export default class InvoicePanel extends Vue {
  @Prop({
    required: true,
  })
  invoice: Invoice;

  invoiceDetails = [];
  options: any = null;

  print() {
    const table: any = document.querySelector(
      `#invoice-${this.invoice.invoice_rid} .v-data-table`,
    );

    const iframe = document.createElement("iframe");
    iframe.style.display = "none";
    iframe.onload = () => {
      const iwindow = iframe.contentWindow as Window;

      // удаление iframe из DOM-а после закрытия модального окна печати (независимо от результата)
      iwindow.onafterprint = function() {
        iframe.remove();
      };

      const doc: any = iframe.contentDocument;
      iwindow.document.body.innerHTML = table.outerHTML;

      doc.title = this.isKz ? "Жеке кабинет" : "Личный кабинет";

      // Добавление стилей
      doc.body.innerHTML =
        doc.body.innerHTML +
        `<style>
            * {
              color: #222;
            }

            table {
              border-collapse: collapse
            }

            table, th, td {
              border: 1px solid #222;
            }

            th, td {
              padding: 0.5em;
            }

            .text-right {
              text-align: right;
            }
          </style>`;

      iwindow.print();
    };
    document.body.appendChild(iframe);
  }

  get isKz() {
    return this.$i18n.locale === "kk";
  }

  get headers() {
    const result: any = [];
    const headers = [
      { label: "name", value: "serv_type_name", width: 130 },
      { label: "code", value: "unit_code", width: 130 },
      { label: "unit", value: "measure_short_name" },
      { label: "quantity", value: "qty_invoice", align: "right" },
      { label: "price", value: "price_invoice", align: "right" },
      { label: "cost", value: "sum_without_nds", width: 150, align: "right" },
      { label: "tax_rate", value: "rate_nds_invoice", align: "right" },
      { label: "tax_sum", value: "sum_nds_invoice", align: "right" },
      { label: "cost_with_tax", value: "sum_all_invoice", align: "right" },
    ];

    headers.forEach(header => {
      result.push({
        text: this.$t(`invoices.headers.${header.label}`),
        value: header.value,
        width: header?.width || "",
        align: header?.align || "",
      });
    });

    return result;
  }

  async getInvoice() {
    this.invoiceDetails = await InvoicesModule.getInvoiceDetails(
      this.invoice.invoice_rid,
    );
  }

  get items(): InvoiceDetails[] {
    return translate(this.invoiceDetails);
  }

  get formattedItems() {
    return this.items.map(item => ({
      ...item,
      qty_invoice: formatDecimal(item.qty_invoice),
      sum_without_nds: formatDecimal2(item.sum_without_nds),
      sum_nds_invoice: formatDecimal2(item.sum_nds_invoice),
      sum_all_invoice: formatDecimal2(item.sum_all_invoice),
      rate_nds_invoice: item.rate_nds_invoice
        ? item.rate_nds_invoice + "%"
        : "",
    }));
  }

  get totals() {
    const invoice: any = this.items[0] || {};
    return [
      {
        label: this.$t("invoices.headers.total_taxable"),
        total_cost: formatDecimal2(invoice?.taxable_without_nds),
        total_tax: formatDecimal2(invoice?.taxable_nds),
        total_final: formatDecimal2(invoice?.taxable),
      },
      {
        label: this.$t("invoices.headers.total_nontaxable"),
        total_cost: formatDecimal2(invoice?.nontaxable_without_nds),
        total_tax: formatDecimal2(invoice?.nontaxable_nds),
        total_final: formatDecimal2(invoice?.nontaxable),
      },
      {
        label: this.$t("invoices.headers.total"),
        total_cost: formatDecimal2(invoice?.total_without_nds),
        total_tax: formatDecimal2(invoice?.total_nds),
        total_final: formatDecimal2(invoice?.total),
      },
    ];
  }

  status(statusName: string) {
    switch (statusName) {
      case "canceled":
        return 1;
      case "canceled2":
        return 2;
      case "delivered":
        return 3;
      case "imported":
        return 4;
      case "rejected":
        return 5;
      case "withdrawn":
        return 6;
      case "wrong":
        return 7;
      case "draft":
        return 8;
      case "not_viewed":
        return 9;
      case "created":
        return 10;
    }
  }
}
